import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export function KPICard({ title, value, subtitle, trend, icon: Icon, variant = "default" }) {
  const borderColor = variant === "success"
    ? "border-l-[#2D4A3E]"
    : variant === "warning"
    ? "border-l-[#E3B505]"
    : variant === "danger"
    ? "border-l-[#E07A5F]"
    : "border-l-[#1A362D]";

  return (
    <div
      data-testid={`kpi-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
      className={`kpi-card bg-white border border-[#E7E5DF] rounded-md p-6 border-l-4 ${borderColor}`}
    >
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#78716C]">
            {title}
          </p>
          <p className="text-2xl sm:text-3xl font-semibold text-[#1C1917] font-['Playfair_Display']">
            {value}
          </p>
          {subtitle && (
            <p className="text-sm text-[#57534E]">{subtitle}</p>
          )}
        </div>
        <div className="flex flex-col items-end gap-1">
          {Icon && <Icon className="w-5 h-5 text-[#8A9A86]" />}
          {trend !== undefined && trend !== null && (
            <span className={`flex items-center gap-1 text-xs font-medium ${
              trend > 0 ? "text-[#2D4A3E]" : trend < 0 ? "text-[#E07A5F]" : "text-[#78716C]"
            }`}>
              {trend > 0 ? <TrendingUp className="w-3 h-3" /> : trend < 0 ? <TrendingDown className="w-3 h-3" /> : <Minus className="w-3 h-3" />}
              {trend > 0 ? "+" : ""}{trend}%
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
